import { t } from "i18next";

export const convertConfigUser = (value: string): string => {
  let returnValue = "";
  switch (value) {
    case "ALL":
      returnValue = t("admin.config.showAll");
      break;
    case "MY_LIST":
      returnValue = t("admin.config.showInvited");
      break;
  }
  return returnValue;
};
export const convertConfigEditor = (value: string): string => {
  let returnValue = "";
  switch (value) {
    case "ALL":
      returnValue = t("admin.config.forAllEditor");
      break;
    case "INTERNAL_USER":
      returnValue = t("admin.config.userInternalUserOnly");
      break;
    case "DENY":
      returnValue = t("admin.common.label.doNotUse");
      break;
  }
  return returnValue;
};
export const convertConfigUnWrapping = (value: string): string => {
  let returnValue = "";
  switch (value) {
    case "ALL":
      returnValue = t("admin.config.policy.allowAll");
      break;
    case "INTERNAL_USER":
      returnValue = t("admin.config.policy.allowInternal");
      break;
    case "MASTER":
      returnValue = t("admin.config.policy.allowFileManager");
      break;
    case "NONE":
      returnValue = t("admin.config.policy.notAllow");
      break;
  }
  return returnValue;
};

export const convertConfigWebOfficeType = (value: string): string => {
  let returnValue = "";
  switch (value) {
    case "OOS":
      returnValue = "OOS";
      break;
    case "OFFICE365":
      returnValue = "Office 365";
      break;
    case "THINKFREE":
      returnValue = "ThinkFree";
      break;
    case "COLLABORA":
      returnValue = "Collabora";
      break;
    case "Office 365":
      returnValue = "OFFICE365";
      break;
    case "ThinkFree":
      returnValue = "THINKFREE";
      break;
    case "Collabora":
      returnValue = "COLLABORA";
      break;
    default:
      returnValue = "";
      break;
  }
  return returnValue;
};
